<template>
    <div class="check-list-item-box" @click="handleClick" :class="isChecked ? 'checked':''" >
        <div class="checkbox-item" v-if="view" @click.stop="">
            <input v-show="!loading" :id="'checkbox-inp-' +item.id" :name="'checkbox-inp-' +item.id" @change.stop="handleCheckboxClick" type="checkbox" :checked="value"> <label
                :for="'checkbox-inp-' +item.id"></label>
        </div>
        <div class="quantity-box" v-if="!isChecked && !view">
            <span class="quantity"><span class="current">{{item.count}}</span> / {{item.total}}</span>
            <post-date :post="item"></post-date>
        </div>
        <span class="icon-box" v-if="isChecked && !view">
            <icon-base width="18" height="18" viewBox="0 0 18 18"><icon-check/></icon-base>
        </span>
        <div class="data-box">
            <p class="title"><span v-if="item.favorite">*</span> {{item.title}}</p>
            <post-date :post="item"></post-date>
        </div>
        <slot></slot>
        <span v-if="draggable" class="draggable-icon handle">
            <icon-base width="10" height="16" viewBox="0 0 10 16"><icon-draggable/></icon-base>
        </span>
    </div>
</template>

<script>

    import PostDate from "../KnowledgeBase/PostDate";
    import IconBase from "../common/IconBase";
    import IconDraggable from "../common/icons/IconDraggable";
    import IconCheck from "../common/icons/IconCheck";
    export default {
        name: 'branch-list-item',
        components: {IconCheck, IconDraggable, IconBase, PostDate},
        props: {
            item: Object,
            draggable: Boolean,
            view: { type:Boolean, default: true},
            value: Boolean,
        },
        data() {
            return{
                loading: false
            }
        },
        methods: {
            handleClick() {
                //console.log('tab click')
                this.$emit('open')
            },
            handleCheckboxClick(e) {
                //console.log('checkbox click');
                this.$emit('input', e.target.checked)
            }
        },
        computed: {
            isChecked() {
                return (this.item.count === this.item.total) && !this.view
            }
        },
    }
</script>

<style scoped>
  .data-box .title {
      cursor: pointer;
  }

</style>
